import { Typography } from 'antd'
import { PhoneButton } from '@/src/components'

import { Physician } from '@/src/interfaces'

const { Text } = Typography

export const PhoneButtonInfo = ({ physician }: { physician: Physician }) => {
  return (
    <>
      <div data-testid='phone-button' className='print:hidden'>
        <div className='w-fit'>
          <PhoneButton
            color='primary'
            variant='solid'
            text='View Phone Number'
            physician={physician}
            isProfileCard={true}
          />
        </div>
      </div>
      <div className='hidden print:flex print:flex-col'>
        <Text strong>Phone Number:</Text>
        <Text>{physician.phone}</Text>
      </div>
    </>
  )
}
